export const FEE_PAYABLE_BY = {
  shipper: 'shipper',
  customer: 'customer'
}
